<template>
    <div id="PartnerIndex" class="index" v-if="!isFirstLoading">
        <BannerKV
        :banners="bannerImages"
        :isShowDot="true"
        :autoplay="false"
        v-on:onBannerSliderChange="onBannerSliderChange"/>

        <NotPartner v-if="!isPartner"/>

        <div v-else>
            <SearchBar class="partner-cruiseSearch"
            :cruiseFilters='pageData.cruiseFilters'
            :isShowHp="true"
            :rowCruiseSearchHandler="rowCruiseSearchHandler"
            />

          

            <div class="partner-cruise-switch">
                  
                <div class="partner-cruise-switch-container">
                    <div class="partner-cruise-item partner-cruise-hp" :class="{ active: mode == 'hp'}" @click="onModeChange('hp')">
                        <img src="https://resource.rcclchina.com.cn/partner/switch-hp.jpg">
                        <div class="img-cover"></div>
                        <div class="partner-cruise-title">中国出发航线</div>
                        <div class="partner-cruise-arrow">
                            <img src="https://resource.rcclchina.com.cn/partner/cruise-switch-arrow.png">
                        </div>
                    </div>
                    <div class="partner-cruise-item partner-cruise-row" :class="{ active: mode == 'row'}" @click="onModeChange('row')">
                        <img src="https://resource.rcclchina.com.cn/partner/switch-row.jpg">
                        <div class="img-cover"></div>
                        <div class="partner-cruise-title">海外出发航线</div>
                        <div class="partner-cruise-arrow">
                            <img src="https://resource.rcclchina.com.cn/partner/cruise-switch-arrow.png">
                        </div>
                    </div>
                </div>
            </div>

            <PartnerCruise
            :isRow="mode=='row'"
            :cruises="cruises"
            :hotCruises="hotCruises"
            :showLoginPopup="showLoginPopup"
            :rowCruiseSearchHandler="rowCruiseSearchHandler"/>

            <div class="partner-rule">
                <div class="container" v-if="contentText">
                    <p class="partner-title">{{contentText.title}}</p>
                    <!-- <div class="partner-rule-content">
                        <p>尊敬的企业合作伙伴你好，</p>
                        <p>非常感谢你选择皇家加勒比国际游轮。</p>
                        <p>由于运营调整需要，企业合作伙伴项目暂时停止运行，在此期间预订船票无法提供合作伙伴优惠价格，具体恢复时间待定并将另行通知。</p>
                        <p style="text-align: right;margin-top: 15px;">2025年2月28日</p>
                    </div> -->
                    <div v-html="contentText.content">

                    </div>
                </div>
            </div>

            <!-- 企业合作伙伴条款须知 -->
            <div class="bottom-tip" @click="showComponePopupShowModel">
                企业合作伙伴条款须知
            </div>

            <AllowTuiPopup
                :isShow="isShowAllowTuiPopup"
                :onAllowTuiClick="onAllowTuiClick"
                v-on:onModalClose="isShowAllowTuiPopup=false"
            />

        </div>
        <LoginModal
        v-if="isShowLoginPopup"
        :onLoginSuccessHandler="onLoginSuccessHandler"
        :isShow="isShowLoginPopup"/>

        <CompanyConfirmPopup v-if="isShowCompanyConfirmPopup" :popupData="popupData"
        @closePromptPopups="closePromptPopups"
        @submitFn="submitFn"
        :isShowCompanyConfirmFn="isShowCompanyConfirmFn"
        />
        <CompanyConfirmAlert v-if="isShowCompanyConfirmAlert" @cancleFn="cancleFn" @confirmFn="confirmFn"/>
    </div>
</template>

<script>
import api from '@/api'
const BannerKV = () => import('@/components/BannerKV')
const SearchBar = () => import('@/components/SearchBar/SearchBar')
const NotPartner = () => import('@/components/Partner/NotPartner')
const PartnerCruise = () => import('@/components/Partner/PartnerCruise')
const AllowTuiPopup = () => import('@/components/Common/AllowTuiPopup')
const LoginModal = () => import('@/components/User/LoginModal.vue')

const CompanyConfirmPopup = () => import('@/components/Partner/CompanyConfirmPopup')
const CompanyConfirmAlert = () => import('@/components/Partner/CompanyConfirmAlert')

import {  gioRecord } from '@/utilities/tools'
const AGREE_PRIVACY = "AGREE_PRIVACY";
import Cookies from "js-cookie";

export default {
    name: "PartnerIndex",
    components: {
        BannerKV,
        NotPartner,
        SearchBar,
        AllowTuiPopup,
        PartnerCruise,
        LoginModal,
        CompanyConfirmPopup,
        CompanyConfirmAlert
    },
    data () {
        return {
            pageData: {},
            isFirstLoading: true,
            isShowAllowTuiPopup: false,
            rowUrl:"",
            mode: "hp",
            isShowLoginPopup: false,
            loginCallback: null,
            allowTuiData:{},
            contentText:null,
            isShowCompanyConfirmPopup:false,
            isShowCompanyConfirmAlert:false,
            isShowCompanyConfirmFn:false,
            popupData: {},
        }
    },
    beforeMount () {
        this.initPage()

        // 获取公告
        this.getContentByKey()
    },
    watch:{
        isPartner:{
            handler(val){
                console.log('isPartner',val)
                if(val){
                    // 登陆状态 获取用户是否 确定 企业合作伙伴条款须知
                    this.showComponePopup()
                }
            },
            immediate:true
        }
    },
    methods: {
        // 请求接口 确定已经 阅读 企业合作伙伴条款须知
        async submitFn(){
            console.log('提交')
            const { success } = await api.partner.submitPartnerClause({
                userName : this.$store.state.user.userToken,
                IsAgreeClause : true,
            })
            console.log(success,'success')
            if (success) {
                this.$alert.show('提交成功')
                // 隐藏弹框
                this.isShowCompanyConfirmAlert = false
                this.isShowCompanyConfirmPopup = false
            } 
        },
        // 点击 企业合作伙伴条款须知 关闭按钮 弹出弹框
        closePromptPopups(){
            // 点击企业须知按钮 不显示确认 按钮
            if(this.isShowCompanyConfirmFn == true){
                this.isShowCompanyConfirmAlert = true
            }else{
                this.isShowCompanyConfirmPopup = false
            }
        },
        // 返回退出  关闭弹框退出登陆
        cancleFn(){
            // console.log('cancleFn')
            this.isShowCompanyConfirmAlert = false
            this.isShowCompanyConfirmPopup = false
            gioRecord('track', 'evt_MainMenu', {
                menu:8,
                subMenu:5,
                desUrl:''
            })
            window.sessionStorage.setItem(AGREE_PRIVACY, "null");
            this.$store.commit("REMOVE_USER_TOKEN");
            Cookies.remove("authed", { path: "/" });
            location.reload();
        },
         // 继续确认 
        confirmFn(){
            // console.log('cancleFn')
            this.isShowCompanyConfirmAlert = false
        },
        showComponePopupShowModel(){
             this.isShowCompanyConfirmPopup = true
            //  关闭确认条款 
            this.isShowCompanyConfirmFn = false
        },
        async showComponePopup(){
            
            const { data } = await api.partner.getPartnerClause({
                userName : this.$store.state.user.userToken
            })
            if (data) {
                console.log(data,'showComponePopup')
                // this.contentText = data
                if(data.isAgreeClause == false){
                    // 显示弹框
                    this.isShowCompanyConfirmPopup = true
                    //  开启确认条款 
                    this.isShowCompanyConfirmFn = true
                }
                this.popupData = data.clauseContent ? data.clauseContent : {}
            } 
        },
        // 获取公告
        async getContentByKey () {
            const { data } = await api.partner.getContentByKey({
                key: 'PPP_OfficialNotice'
            })
            if (data) {
                // console.log(data,'datadata')
                this.contentText = data
            } 
        },
        async initPage () {
            const request = {
                userToken: this.userToken,
                pppKey: this.pppKey
            }
            const { data } = await api.partner.indexPage(request)
            this.isFirstLoading = false
            if (data) {
                if (data.partner) {
                    this.pageData = data.partner
                }
                if (data.pppKey && data.pppKey.length > 0) {
                    this.$store.commit('SET_PPP_KEY', data.pppKey)
                }
            }
            const res = await api.partner.isAllowTuiByToken(this.userToken)
            let cruiseUrl = process.env.VUE_APP_TUI_URL + "/Cruise/Search";
            if (!res.data) {
                this.rowUrl = cruiseUrl
                this.isShowAllowTuiPopup = true
                return
            }
        },
        onBannerSliderChange (index) {
            this.mode = index == 0 ? 'hp': 'row'
        },
        async rowCruiseSearchHandler (url) {
            // const { data } = await api.partner.isAllowTuiByToken(this.userToken)
            // if (!data) {
            //     this.rowUrl = url
            //     this.isShowAllowTuiPopup = true
            //     return
            // }
            this.goTui(url)
        },
        async onAllowTuiClick (isAllow) {
            let rowUrl = this.rowUrl + ""
            if (!rowUrl || rowUrl.length == 0) {
                rowUrl = process.env.VUE_APP_TUI_URL + "/Cruise/Search"
            }
            if (!isAllow) {
                this.goTui(rowUrl)
            } else {
                await api.partner.allowTui()
                this.goTui(rowUrl)
            }
        },
        async goTui (rowUrl) {
            const { data } = await api.partner.goTui({
                userName: this.userToken,
                url: rowUrl
            })
            if (data) {
                location.href = data
            } else {
                location.href = rowUrl
            }
        },
        onModeChange (mode) {
            this.mode = mode
            // todo slide banner
        },
        showLoginPopup (callback) {
            this.isShowLoginPopup = true
            this.loginCallback = callback
        },
        onLoginSuccessHandler () {
            this.isShowLoginPopup = false
            if (this.loginCallback) {
                this.loginCallback()
                this.loginCallback = null
            }
        }
    },
    computed: {
        userToken () {
            return this.$store.state.user.userToken || ""
        },
        userMobile () {
            const userInfo = this.$store.state.user.userInfo || {}
            return userInfo.mobile || ""
        },
        pppKey () {
            return this.$store.state.user.pppKey || ""
        },
        bannerImages () {
            return [{
                image: "https://resource.rcclchina.com.cn/partner/not_login-banner-1.jpg",
            }, {
                image: "https://resource.rcclchina.com.cn/partner/not_login-banner-2.jpg"
            }]
        },
        isPartner () {
            return this.pageData.isPartner || false
        },
        isAllowTui () {
            return this.pageData.isAllowTui || false
        },
        cruises () {
            if (!this.pageData || !this.pageData.cruiseViewModels) {
                return []
            }
            if (this.mode == 'hp') {
                return this.pageData.cruiseViewModels.filter(r=>r.isRow == false)
            } else {
                return this.pageData.cruiseViewModels.filter(r=>r.isRow)
            }
        },
        hotCruises () {
            if (!this.pageData || !this.pageData.hotCruiseViewModels) {
                return []
            }
            if (this.mode == 'hp') {
                return this.pageData.hotCruiseViewModels.filter(r=>r.isRow == false)
            } else {
                return this.pageData.hotCruiseViewModels.filter(r=>r.isRow)
            }
        }
    }
}
</script>

<style lang="less" scoped>
.index {
    position: relative;
    min-width: 1200px;
    top: -72px;

    .partner-rule {
        margin-top: 92px;
        padding-bottom: 100px;
        .container {
            width: 1200px;
        }
        .partner-rule-content {
            color: #747d80;
            font-size: 16px;
            font-weight: 400;
            margin-top: 60px;
            p {
                margin-bottom: 0px;
                line-height: 28px;
            }
        }
    }

}
</style>

<style lang="less">
#PartnerIndex {
    #banner {
        .carousel-control {
            display: none;
        }
    }
    .partner-bannerDot {
        bottom: 70px;
        .bannerDot {
            display: inline-block;
            vertical-align: middle;
            background-color: white;
            width: 60px;
            height: 5px;
            cursor: pointer;
            opacity: 1;
        }
        .bannerDot:first-child {
            margin-right: 15px;
        }
        .bannerDot.active {
            width: 90px;
            background-color: #ffcd00;
        }
    }
    .partner-title {
        font-size: 50px;
        color: #121920;
        font-weight: 600;
        letter-spacing: 4px;
        margin-bottom: 25px;
        text-align: center;
    }

    .partner-subTitle {
        color: #333333;
        font-size: 24px;
    }

    .partner-cruiseSearch {
        margin-top: 0px;
    }

    .partner-cruise-switch {
        margin-top: 50px;
        position: relative;
        width: 100%;
        .partner-cruise-switch-container {
            position: relative;
            width: 1200px;
            margin: auto;
            text-align: center;
            .partner-cruise-item {
                position: relative;
                width: 450px;
                display: inline-block;
                cursor: pointer;
                img {
                    width: 100%;
                    height: 100%;
                }
                .img-cover {
                    width: 100%;
                    height: 100%;
                    background-color: rgba(0, 0, 0, 0.5);
                    position: absolute;
                    top: 0;
                }
                .partner-cruise-title {
                    position: absolute;
                    width: 100%;
                    top: 0px;
                    color: white;
                    font-size: 30px;
                    font-weight: 500;
                    letter-spacing: 4px;
                    top: 50%;
                    transform: translateY(-50%);
                }
                .partner-cruise-arrow {
                    position: absolute;
                    display: none;
                    z-index: 2;
                    width: 100%;
                    bottom: -20px;
                    img {
                        width: 41px;
                        height: 41px;
                    }
                }
            }
            .partner-cruise-item.partner-cruise-hp {
                margin-right: -6px;
            }
            .partner-cruise-item.active {
                width: 533px;
                height: 170px;
                z-index: 1;
                border-bottom: solid 3px #ffcd00;
                .img-cover {
                    background-color: rgba(0, 0, 0, 0.1);
                }
                .partner-cruise-arrow {
                    display: block;
                }
            }
        }
    }
}

.bottom-tip{
    position: absolute;
    left: 50%;
    bottom: -30px;
    font-weight: 500;
    font-size: 28px;
    color: #006AB9;
    line-height: 40px;
    text-align: left;
    font-style: normal;
    text-decoration-line: underline;
    transform: translate(-50%, 0%);
    cursor: pointer;
}

</style>
